import axios from 'axios'
import { deviceUrl, IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 统计各类型设备数量
export function deviceCountType(params) {
  const url = deviceUrl + '/device/count/type'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '统计各类型设备数量', res)
    }
    return Promise.resolve(res.data)
  })
}
// 统计设备分配状态情况
export function deviceCountDistribut(params) {
  const url = deviceUrl + '/device/count/distribution'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '统计设备分配状态情况', res)
    }
    return Promise.resolve(res.data)
  })
}
// 统计设备运行时间情况
export function deviceCountTime(params) {
  const url = deviceUrl + '/device/count/time'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '统计设备运行时间情况', res)
    }
    return Promise.resolve(res.data)
  })
}
// 设备动态信息展示
export function deviceHistory(params) {
  const url = deviceUrl + '/device/history'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '查询设备动态信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 设备状态分析
export function healthStatus(params) {
  const url = IhLogUrl + '/health/status'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '设备状态分析', res)
    }
    return Promise.resolve(res.data)
  })
}

// 设备剩余电量
export function batterysStatus(params) {
  const url = IhLogUrl + '/batterys/charge/status'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '设备剩余电量', res)
    }
    return Promise.resolve(res.data)
  })
}
